import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./lib/i18n";
import AgeGate from "./components/AgeGate";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import GetStarted from "./pages/GetStarted";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterPlayer from "./pages/RegisterPlayer";
import RegisterStreamer from "./pages/RegisterStreamer";
import PlayerDashboard from "./pages/PlayerDashboard";
import StreamerDashboard from "./pages/StreamerDashboard";
import StreamerOnboarding from "./pages/StreamerOnboarding";
import AdminDashboard from "./pages/AdminDashboard";
import Imprint from "./pages/legal/Imprint";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import Responsible from "./pages/legal/Responsible";
import VerifyEmail from "./pages/VerifyEmail";
import PublicStreamer from "./pages/PublicStreamer";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import Marketplace from "./pages/Marketplace";
import UnlockPlaceholder from "./pages/UnlockPlaceholder";
import Onboarding from "./pages/Onboarding";
import FAQ from "./pages/FAQ";
import HowItWorks from "./pages/HowItWorks";
import EmailBanner from "./components/EmailBanner";

function Shell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <EmailBanner />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AgeGate />
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Shell><Landing /></Shell>} />
            <Route path="/get-started" element={<Shell><GetStarted /></Shell>} />
            <Route path="/login" element={<Shell><Login /></Shell>} />
            <Route path="/register" element={<Shell><Register /></Shell>} />
            <Route path="/register/player" element={<Shell><RegisterPlayer /></Shell>} />
            <Route path="/register/streamer" element={<Shell><RegisterStreamer /></Shell>} />
            <Route path="/player" element={<ProtectedRoute roles={["player"]}><Shell><PlayerDashboard /></Shell></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute roles={["player"]}><Shell><Onboarding /></Shell></ProtectedRoute>} />
            <Route path="/streamer" element={<ProtectedRoute roles={["streamer"]}><Shell><StreamerDashboard /></Shell></ProtectedRoute>} />
            <Route path="/streamer/onboarding" element={<ProtectedRoute roles={["streamer"]}><Shell><StreamerOnboarding /></Shell></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Shell><AdminDashboard /></Shell></ProtectedRoute>} />
            <Route path="/legal/imprint" element={<Shell><Imprint /></Shell>} />
            <Route path="/legal/privacy" element={<Shell><Privacy /></Shell>} />
            <Route path="/legal/terms" element={<Shell><Terms /></Shell>} />
            <Route path="/legal/responsible" element={<Shell><Responsible /></Shell>} />
            <Route path="/faq" element={<Shell><FAQ /></Shell>} />
            <Route path="/how-it-works" element={<Shell><HowItWorks /></Shell>} />
            <Route path="/verify-email" element={<Shell><VerifyEmail /></Shell>} />
            <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
            <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
            <Route path="/change-password" element={<ProtectedRoute><Shell><ChangePassword /></Shell></ProtectedRoute>} />
            <Route path="/marketplace" element={<ProtectedRoute roles={["streamer","admin"]}><Shell><Marketplace /></Shell></ProtectedRoute>} />
            <Route path="/marketplace/:playerId/unlock" element={<ProtectedRoute roles={["streamer","admin"]}><Shell><UnlockPlaceholder /></Shell></ProtectedRoute>} />
            <Route path="/s/:slug" element={<Shell><PublicStreamer /></Shell>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
